module.exports = __webpack_public_path__ + "static/img/zh.1aacb644.png";